/** 外部リンク用URL */
export namespace ExternalLink {
  /** FAQ：マイページのログイン方法 */
  export const FAQ_LOGIN_PROCEDURE =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge3033.html';
  /** ご請求明細の発行をご希望の方 */
  export const RETURN_DEVICE_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge9906.html';
  /** MANOMA解約申請フォーム */
  export const QUIT_FORM_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/form292.html';
  /** MANOMA サポートデスク */
  export const MANOMA_SUPPORT_DESK_URL = 'https://support.sonynetwork.co.jp/manoma/web/index.html';
  /** 個人情報の取り扱い */
  export const DESCRIPTION_URL = 'https://manoma.jp/legal/privacypolicy.pdf';
  /**  ご請求明細の発行をご希望の方 */
  export const BILLING_DETAILS_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge9909.html';
  /**  「機器購入プラン」の対象のプラン */
  export const EQUIPMENT_PURCHASE_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge10364.html';
  /** 機器残債金の確認方法 */
  export const EQUIPMENT_BALANCE_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge3134.html';
  /**  解約違約金の有無 */
  export const CANCEL_PENALTY_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge3131.html';
  /** 機器のご返却に関する注意事項 */
  export const RETURN_PRECAUTIONS_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge9906.html';
  /**  返却先および返却方法 */
  export const RETURN_WAY_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge3133.html';
  /**  解約違約金に関する詳しい内容 */
  export const CANCEL_PENALTY_EXPLANATION =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge3131.html';
  /** サポート窓口 */
  export const SUPPORT_DESK_URL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/index.html';
  /** 機器返却についての詳細 */
  export const RETURN_EQUIPMENT_DETAIL =
    'https://support.sonynetwork.co.jp/faqsupport/manoma/web/knowledge9906.html';
  /** MANOMA サービス利用規約 */
  export const MANOMA_KIYAKU_URL = 'https://manoma.jp/legal/kiyaku.pdf';
  /** MANOMA 重要事項（※特定商取引法に基づく表示） */
  export const MANOMA_JUSETSU_URL = 'https://manoma.jp/legal/jusetsu.pdf';
  /** MANOMA 対応機器貸与サービス利用規約 */
  export const MANOMA_KIYAKU_TAIYO_URL = 'https://manoma.jp/legal/kiyaku_taiyo.pdf';
  /** MANOMA 対応機器貸与サービス 重要事項（※特定商取引法に基づく表示） */
  export const MANOMA_JUSETS_TAIYO_URL = 'https://manoma.jp/legal/jusetsu_taiyo.pdf';
  /** MANOMAプライバシーポリシー */
  export const MANOMA_PRIVACY_POLICY_URL = 'https://manoma.jp/legal/privacypolicy.pdf';
}

export namespace ApiUrl {
  export const DOMAIN = process.env.NEXT_PUBLIC_BFF_URL;

  /** 認証API */
  export namespace Authn {
    /** マイページログアウト */
    export const LOGOUT = '/api/authn/logout';
    /** クレデンシャル更新 */
    export const RENEW = '/api/authn/renew';
  }
  /** 非認証API */
  export namespace NonProtected {
    /** マイページログイン */
    export const LOGIN = '/api/v1/login';
    /** ワンタイムパスワード発行 */
    export const ONETIME_PASSWORD = '/api/v1/send-onetime-url';
    /** ワンタイムパスワード検証 */
    export const VALIDATE_ONETIME_PASSWORD = '/api/v1/validate-onetime-password';
    /** パスワードリセット */
    export const PASSWORD_RESETTING = '/api/v1/password-reset';
  }

  /** 参照系API */
  export namespace Read {
    /** 顧客情報照会 */
    export const CUSTOMER_INFO = '/api/read/v1/customer-state-info';
    /** 契約情報取得 */
    export const CONTRACT_INFO = '/api/read/v1/customer-info';
    /** オプション情報取得 */
    export const PROVIDE_OPTIONS_INFO = '/api/read/v1/provide-option';
    /** 解約申込情報 */
    export const QUIT_PROVIDE_INFO = '/api/read/v1/provide-quit-option';
    /** 請求情報(ご請求料金一覧) */
    export const BILLING_INFO_LIST = '/api/read/v1/billing-list';
    /** 返還情報 */
    export const PAYMENT_INFO = '/api/read/v1/repay-list';
    /** インボイス返還明細取得 */
    export const REPAYMENT_INFO = '/api/read/v1/repay-detail';
    /** 請求情報(欲しい月の取得) */
    export const BILLING_INFO_ONLY = '/api/read/v1/billing-detail';
    /** インボイス総額明細取得 */
    export const BILLING_INFO_TOTAL_INCOICE = '/api/read/v1/installment';
    /** 残債金詳細情報 */
    export const QUIT_INSTLMT_RMND_INFO = '/api/read/v1/instlmt-rmnd-prc';
    /** 解約違約金詳細情報 */
    export const QUIT_PNTY_PRC_INFO = '/api/read/v1/quit-pnty-prc';
    /** キャッシュバック情報照会 */
    export const CHASH_BACK_INFO = '/api/read/v1/cashback-info';
    /** クレジットカード情報 */
    export const CREDIT_CARD_INFO = '/api/read/v1/credit-card-info';
    /** 請求情報詳細取得(インボイス) */
    export const BILLING_INVOICE_INFO = '/api/read/v1/billing-detail-invoice';
    /** 集荷先情報を取得 */
    export const PICK_UP_INFO = '/api/read/v1/pick-up-info';
    /** トークンステータス参照 */
    export const TOKEN_SEARCH = '/api/read/v1/token-search/';
    /** 3Dセキュア認証 */
    export const SECURE_AUTH = '/api/read/v1/secure-auth/';
  }
  /** 更新系API */
  export namespace Write {
    /** メールアドレス認証 */
    export const LOGINID_UPDATE_CONFIRM = '/api/write/v1/mail-address-check';
    /** ログインID変更 */
    export const LOGINID_UPDATE = '/api/write/v1/login-id-update';
    /** パスワード変更（更新） */
    export const PASSWORD_UPDATE = '/api/write/v1/password-change';
    /** 契約者情報変更 */
    export const MODIFY_CUSTOMER = '/api/write/v1/customer-modify';
    /** オプション解約 */
    export const OPTION_QUIT = '/api/write/v1/customer-plan-option-change';
    /** オプション契約追加 */
    export const OPTION_ADD = '/api/write/v1/customer-add-option';
    /** 設置先情報変更 */
    export const MODIFY_CONSTRUCTION = '/api/write/v1/construction-modify';
    /** サービス解約 */
    export const SERVICE_QUIT_INFO = '/api/write/v1/b2c-sh-quit';
    /** クレジットカード情報変更 */
    export const CREDIT_CARD_UPDATE = '/api/write/v1/credit-card-update';
    /** 継続利用意思登録 */
    export const CONTINUED_USE_ENTER = '/api/write/v1/enter-continued-use';
    /** キャッシュバック受取 */
    export const CASH_BACK_APPROVAL = '/api/write/v1/cashback-approval';
    /** 集荷情報更新 */
    export const PICK_UP_RENEWAL = '/api/write/v1/pick-up-update';
    /** 3Dセキュア認証結果復号 */
    export const SECURE_RESULT_DECRYPT = '/api/write/v1/secure-result-decrypt';
    /** クレジットカード情報変更(3Dセキュア認証) */
    export const SECURE_CREDIT_CARD_UPDATE = '/api/write/v1/secure-credit-card-update';
  }
}
export namespace Constants {
  export namespace ApiType {
    export const API_GET = 'get';
    export const OPTION_CHANGE = 'optionChange';
    export const API_POST = 'post';
  }
}

export namespace Address {
  export const ADDRESS_PREFECTURE = [
    { label: '北海道', value: '北海道' },
    { label: '青森県', value: '青森県' },
    { label: '岩手県', value: '岩手県' },
    { label: '宮城県', value: '宮城県' },
    { label: '秋田県', value: '秋田県' },
    { label: '山形県', value: '山形県' },
    { label: '福島県', value: '福島県' },
    { label: '茨城県', value: '茨城県' },
    { label: '栃木県', value: '栃木県' },
    { label: '群馬県', value: '群馬県' },
    { label: '埼玉県', value: '埼玉県' },
    { label: '千葉県', value: '千葉県' },
    { label: '東京都', value: '東京都' },
    { label: '神奈川県', value: '神奈川県' },
    { label: '新潟県', value: '新潟県' },
    { label: '富山県', value: '富山県' },
    { label: '石川県', value: '石川県' },
    { label: '福井県', value: '福井県' },
    { label: '山梨県', value: '山梨県' },
    { label: '長野県', value: '長野県' },
    { label: '岐阜県', value: '岐阜県' },
    { label: '静岡県', value: '静岡県' },
    { label: '愛知県', value: '愛知県' },
    { label: '三重県', value: '三重県' },
    { label: '滋賀県', value: '滋賀県' },
    { label: '京都府', value: '京都府' },
    { label: '大阪府', value: '大阪府' },
    { label: '兵庫県', value: '兵庫県' },
    { label: '奈良県', value: '奈良県' },
    { label: '和歌山県', value: '和歌山県' },
    { label: '鳥取県', value: '鳥取県' },
    { label: '島根県', value: '島根県' },
    { label: '岡山県', value: '岡山県' },
    { label: '広島県', value: '広島県' },
    { label: '山口県', value: '山口県' },
    { label: '徳島県', value: '徳島県' },
    { label: '香川県', value: '香川県' },
    { label: '愛媛県', value: '愛媛県' },
    { label: '高知県', value: '高知県' },
    { label: '福岡県', value: '福岡県' },
    { label: '佐賀県', value: '佐賀県' },
    { label: '長崎県', value: '長崎県' },
    { label: '熊本県', value: '熊本県' },
    { label: '大分県', value: '大分県' },
    { label: '宮崎県', value: '宮崎県' },
    { label: '鹿児島県', value: '鹿児島県' },
    { label: '沖縄県', value: '沖縄県' },
  ];
}

/** 支払方法 */
export namespace PaymentType {
  /** クレジットカード */
  export const CREDIT_CARD_PAY = '30';
  export const BUSINESS = '50';
  export const PAID_PAY = '80';
}

/** プラン */
export namespace PlanCode {
  /** レンタルプラン（定期契約プラン） */
  export const RENTAL_PLAN = 'JP44MA';
  /** 戸建てプラン for NURO） */
  export const KODATE_PLAN = 'JP47MA';
  /** マンションプラン for NURO） */
  export const MANSION_PLAN = 'JP48MA';
}

/** 契約ステータス */
export namespace State {
  /** 受付 */
  // export const HOGE = 'S01';
  /** 不備 */
  // export const HOGE = 'S02';
  /** キャンセル */
  // export const HOGE = 'S03';
  /** 新規利用申込中 */
  // export const HOGE = 'S04';
  /** 利用中 */
  export const USE_STATE = 'S05';
  /** 一時利用停止中 */
  // export const HOGE = 'S06';
  /** 解約中 */
  export const ON_QUIT = 'S07';
  /** 解約完了 */
  // export const HOGE = 'S08';
}

/** オプション申込ステータス */
export namespace OptionProposalStatus {
  /** PREV: 未申込 */
  export const PREV = 'PREV';
  /** PROPOSAL: 申込 */
  export const PROPOSAL = 'PROPOSAL';
  /** RELATION_PROPOSAL: 申込選択中 */
  export const RELATION_PROPOSAL = 'RELATION_PROPOSAL';
  /** PROCESS: 申込処理中 */
  export const PROCESS = 'PROCESS';
  /** SERV: 利用中 */
  export const SERV = 'SERV';
  /** QUIT_PROCESS: 解約処理中 */
  export const QUIT_PROCESS = 'QUIT_PROCESS';
  /** ON_QUIT_PROCESS: 解約選択中 */
  export const ON_QUIT_PROCESS = 'ON_QUIT_PROCESS';
}

/** 物流ステータス */
export namespace LogisticsStatus {
  /** 新規 */
  export const NEW = '10101';
  /** 回収中 */
  export const COLLECTING = '10200';
  /** 回収中(未督促) */
  export const COLLECTING_UNDAUNTED = '10201';
  /** 回収中(督促) */
  export const COLLECTING_DEMAND = '10202';
  /** 完了 */
  export const COMPLETE = '10400';
  /** 完了(回収済み) */
  export const COMPLETE_RECOVERED = '10401';
  /** 完了(回収不能) */
  export const COMPLETE_UNCOLLECTIBLE = '10402';
}

/** 回収状況ステータス */
export namespace ReturnStatus {
  /** 回収中(未督促) */
  export const COLLECTING_UNDAUNTED = '1';
  /** 回収中(督促) */
  export const COLLECTING_DEMAND = '2';
  /** 完了(回収済み) */
  export const COMPLETE_RECOVERED = '3';
  /** 完了(回収不能) */
  export const COMPLETE_UNCOLLECTIBLE = '4';
  /** キャンセル */
  export const CANCEL = '5';
}

/** バリデーションチェック */
export namespace RegrexPattern {
  /** 市外局番 */
  export const tel = /^[0]{1}[0-9]{9}$/;
  /** 携帯番号 */
  export const mobilePhone = /^0[1-9]{1}0[0-9]*$/;
  /** 携帯番号010-050 */
  export const mobilePhone1t5 = /^0[1-5]{1}0[0-9]{8}$/;
  /** 携帯番号060-090 */
  export const mobilePhone6789 = /^0[6-9]{1}0[0-9]{8}$/;
}

export namespace Provider {
  export const Id = 'sncm';
}
